module.exports = __webpack_public_path__ + "d81ba1cbb97f2b516970338b502dcf39.png"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/modules/home/components/images/institution.png
 ** module id = 1569
 ** module chunks = 0
 **/